import { googlePlace } from '@codecs/google';

import { LocalLead, localLead } from '@codecs/localLead';
import { HttpRequest } from '@lib/api/httpRequest';
import { environment } from '@lib/environment';
import { RentProjectionRequest } from '@models/RentProjectionRequest';
import { jsonapiCreate, jsonapiGetArray } from '@vacasa/jsonapi';
import axios, { AxiosResponse } from 'axios';
import { createCancelToken } from './cancelToken';

export async function getAddressSuggestions(address: string) {
    const url = '/v1/estimator/address-suggestions';
    return await jsonapiGetArray({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        params: { address },
        cancelToken: createCancelToken('getAddressSuggestions'),
        decoder: googlePlace,
    })
        .then((response) => response.data.data.map((d) => d.attributes))
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`GET ${url} failed`, err);
            }
            return [];
        });
}

export async function getRentProjection(request: RentProjectionRequest): Promise<AxiosResponse> {
    const url = '/v2/estimator/rent-projection';
    const body = {
        data: {
            type: 'rent-projection',
            attributes: { ...request },
        },
    };

    return await new HttpRequest().post(url, body, {
        timeout: 28000,
        cancelToken: createCancelToken('getRentProjection'),
    });
}

export async function saveLocalLead(request: LocalLead): Promise<LocalLead | undefined> {
    const url = '/v1/estimator/local-lead';

    return await jsonapiCreate({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        data: {
            data: {
                type: 'local-lead',
                attributes: { ...request },
            },
        },
        cancelToken: createCancelToken('saveLocalLead'),
        decoder: localLead,
    })
        .then((response) => response.data.data.attributes)
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`POST ${url} failed`, err);
            }
            return undefined;
        });
}
